import { STATE_IDENTIFIER } from "./tcConstants";

const { TABLES_CONFIGURATION, LOADER_IDENTIFIER } = STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [LOADER_IDENTIFIER]: false,
  [TABLES_CONFIGURATION]: [],
};
